import { Modal, Typography, Input, Form } from 'antd';
import TextArea from 'antd/lib/input/TextArea';

import notifier from 'utils/notifier';
import { ErrorResponse } from 'utils/types';
import { getDisplayCompanyId, phoneFormatInput, validateEmailAddress, validatePhoneNumber } from 'utils/helpers';

import FloatLabel from 'components/Common/FloatLabel';

const { Title } = Typography;

type ReportIssueModalProps = {
  companyId: string,
  reportIssue(form: Object): any,
  isReporting: boolean,
  claimNo: string,
  isReportIssueModalVisible: boolean,
  handleReportIssueModalClose(): void,
  status?: string,
}

const ReportIssueModal = (props: ReportIssueModalProps) => {

  const [form] = Form.useForm();

  const submit = () => {

    form.validateFields().then(values => {
      let phoneNumber = values.phone?.replace(/[^A-Z0-9]/ig, '');
      let faxNumber = values.fax?.replace(/[^A-Z0-9]/ig, '');

      let formObject = {
        Contact: values.contactName,
        PhoneNumber: phoneNumber,
        FaxNumber: faxNumber,
        best: values.best,
        Email: values.email,
        ClaimOrAuth: props.claimNo,
        Comment: values.comment,
        Ipa: getDisplayCompanyId(props.companyId),
        Location: '/claims/detail',
        Status: props.status ? props.status : 'FINALIZED',
        UserId: sessionStorage.getItem('user_id'),
      };

      props.reportIssue(formObject)
      .then((response: any) => {
        notifier.success('Thanks for your help.', 'We will contact you regarding this issue as soon as possible.');
        props.handleReportIssueModalClose();
      })
      .catch((err: ErrorResponse) => {
        notifier.error(err.response?.data?.Message || 'Something went wrong, please contact a system administrator.');
      });

    }).catch(err => {
      return;
    })
  }

  const closeModal = () => {
    form.resetFields();
    props.handleReportIssueModalClose();
  }

  return (
    <>
      <Modal
        visible={props.isReportIssueModalVisible}
        onCancel={() => closeModal()}
        onOk={submit}
        className="modal-width"
        confirmLoading={props.isReporting}
      >
        <div className="container">
          <Title level={3}>Report Issue</Title>
        </div>

        <Form
          form={form}
          name="reportIssueForm"
          onFinish={submit}
          initialValues={{
            claimNo: props.claimNo
          }}
        >
          <FloatLabel
            label="Contact Name"
            name="contactName"
            form={form}
            required
          >
            <Input
            />
          </FloatLabel>

          <FloatLabel
            label="Phone Number"
            name="phone"
            form={form}
            required
            rules={[
              () => ({
                validator: validatePhoneNumber
              })
            ]}
          >
            <Input type="tel" onKeyPress={(e: any) =>  form.setFieldsValue({ phone: phoneFormatInput(e)} ) } />
          </FloatLabel>

          <FloatLabel
            label="Fax Number"
            name="fax"
            form={form}
            required
            rules={[
              () => ({
                validator: validatePhoneNumber
              })
            ]}
          >
            <Input type="tel" onKeyPress={(e: any) =>  form.setFieldsValue({ fax: phoneFormatInput(e)} ) } />
          </FloatLabel>

          <FloatLabel
            label="Best Time to Call"
            name="best"
            form={form}
          >
            <Input
            />
          </FloatLabel>

          <FloatLabel
            label="Email Address"
            name="email"
            form={form}
            required
            rules={[
              () => ({
                validator: validateEmailAddress
              })
            ]}
          >
            <Input
            />
          </FloatLabel>

          <FloatLabel
            label="Claim or Auth Number"
            name="claimNo"
            form={form}
          >
            <Input
            />
          </FloatLabel>

          <FloatLabel
            label="Comment"
            name="comment"
            form={form}
            required
          >
            <TextArea
              rows={6}
            />
          </FloatLabel>
        </Form>
        <br />
        Required Fields <span style={{ color: 'red' }}>*</span>
      </Modal>
    </>
   );
}

export default ReportIssueModal;